import { PrimaryButton, SecondaryButton } from '@systemeio/ui'
import { ActionButton } from 'modules/stores/store/components/item-actions/action-button'
import { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

type ItemActionsProps = {
  publish?: ActionButtonBaseProps
  saveDraft?: ActionButtonBaseProps
  next?: ActionButtonBaseProps
}

export type ActionButtonBaseProps = {
  onClick?: () => void
  isFetching?: boolean
  disabled?: boolean
}

const ItemActions: FC<ItemActionsProps> = ({ saveDraft, publish, next }) => {
  const { t } = useLocoTranslation()
  return (
    <div className={'flex flex-col justify-between gap-5 sm:flex-row'}>
      <div className={'flex w-full justify-end'}>
        <div className={'flex w-full flex-col gap-5 sm:w-fit sm:flex-row'}>
          <ActionButton
            ButtonComponent={SecondaryButton}
            {...saveDraft}
            disabled={saveDraft?.disabled || publish?.isFetching}
          >
            {t('dashboard.store.item.save_draft')}
          </ActionButton>
          <ActionButton
            ButtonComponent={PrimaryButton}
            {...publish}
            disabled={publish?.disabled || saveDraft?.isFetching}
          >
            {t('dashboard.store.item.publish')}
          </ActionButton>
          <ActionButton ButtonComponent={PrimaryButton} {...next}>
            {t('global.next')}
          </ActionButton>
        </div>
      </div>
    </div>
  )
}
export default ItemActions
